import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flag-button"
// Handles clicking on flag buttons to flag/unflag questions
export default class extends Controller {
  static values = {
    qnumber: Number
  }

  click(event) {
    event.preventDefault()

    const $ = window.$
    if (!$) {
      console.warn('[flag-button] jQuery not available')
      return
    }

    // Don't handle fake flags
    if ($(this.element).hasClass("fake-flag-yash")) {
      return
    }

    const questionNumber = this.qnumberValue || this.element.getAttribute('data-qnumber')

    if (!questionNumber) {
      console.warn('[flag-button] Missing question number')
      return
    }

    const currentBubble = $("#interface-bottom-current-bubble-" + questionNumber + "-yash")
    const flagCheck = $("#flagged" + questionNumber + "-yash")
    const currentQuestion = window.currentQuestion

    if ($(this.element).hasClass("question-clicked-flag-yash")) {
      // Unflag: remove flag classes
      $(this.element).removeClass("question-clicked-flag-yash")
      currentBubble
        .removeClass("bottom-interface-flag-unclicked-yash")
        .removeClass("bottom-interface-flag-clicked-yash")

      // If this is the current question, add black class back
      if (currentQuestion && currentQuestion.number == questionNumber) {
        currentBubble.addClass("interface-black-yash")
      }

      flagCheck.val("0")
    } else {
      // Flag: add flag classes
      $(this.element).addClass("question-clicked-flag-yash")
      currentBubble
        .addClass("bottom-interface-flag-unclicked-yash")
        .addClass("bottom-interface-flag-clicked-yash")
      currentBubble.removeClass("interface-black-yash")

      flagCheck.val("1")
    }
  }
}

